import { AppointmentsAvailableTimesQuery } from './appointments_available_times_query';
import { AppointmentsConfirmQuery } from './appointments_confirm_query';
import { AppointmentsCoursesQuery } from './appointments_courses_query';
import { AppointmentsLocationsQuery } from './appointments_locations_query';
import { AppointmentsOrganizersQuery1 } from './appointments_organizers_query';
import { AppointmentsReasonQuery } from './appointments_reason_query';
import { AppointmentsServiceCategoriesQuery } from './appointments_service_categories_query';
import { AppointmentsServiceQuery } from './appointments_service_query';
import { CancellationReasonsQuery } from './cancellation_reasons_query';
import { UpcomingAppointmentsQuery } from './upcoming_appointments_query';

angular
  .module('capability-ng-appointments')
  .service('ngCancellationReasonsQuery', CancellationReasonsQuery)
  .service('ngUpcomingAppointmentsQuery', UpcomingAppointmentsQuery)
  .service('ngAppointmentsAvailableTimesQuery', AppointmentsAvailableTimesQuery)
  .service('ngAppointmentsConfirmQuery', AppointmentsConfirmQuery)
  .service('ngAppointmentsCoursesQuery', AppointmentsCoursesQuery)
  .service('ngAppointmentsLocationsQuery', AppointmentsLocationsQuery)
  .service('ngAppointmentsOrganizersQuery1', AppointmentsOrganizersQuery1)
  .service('ngAppointmentsReasonsQuery', AppointmentsReasonQuery)
  .service('ngAppointmentsServiceCategoriesQuery', AppointmentsServiceCategoriesQuery)
  .service('ngAppointmentsServiceQuery', AppointmentsServiceQuery);

export * from './appointments_available_times_query';
export * from './appointments_confirm_query';
export * from './appointments_courses_query';
export * from './appointments_locations_query';
export * from './appointments_organizers_query';
export * from './appointments_reason_query';
export * from './appointments_service_categories_query';
export * from './appointments_service_query';
export * from './cancellation_reasons_query';
export * from './upcoming_appointments_query';



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/queries/queries_module.ts